import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { NavLink } from "react-router-dom";

import { menu } from "./data";

class Header extends Component {
  render() {
    return (
      <header className="page_header ls justify-nav-center">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-2 col-md-2 col-sm-2 col-9">
              <NavLink to="/">
                <a className="logo">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/jmty-logo.png`}
                    alt="img"
                  />
                </a>
              </NavLink>
            </div>
            <div className="col-xl-10 col-1 d-flex align-items-center left px-1">
              <nav className="top-nav">
                <ul className="nav sf-menu">
                  {menu.map(({ value, label, children }, index) => (
                    <li key={`menu-${index}`}>
                      <NavLink to={value}>
                      <a>{label}</a>
                      </NavLink>
                      {children && (
                        <ul style={{width: "250px"}}>
                          {children.map((child, index2) => (
                            <li key={`menu-child-${index2}`}>
                              <NavLink to={child.value} style={{fontSize: "12px", lineHeight: "21px"}}>
                                {child.label}
                              </NavLink>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
              <div className="social-icons social-icons-tilled text-center text-lg-left">
                <a
                  href="https://www.instagram.com/justmovedtoyankee/?igshid=18t23l69fp0ah"
                  target="_blank"
                  className="fab fa-instagram "
                  title="instagram"
                >
                </a>
                <a
                  href="https://www.linkedin.com/company/just-moved-to-yankee-jmty"
                  target="_blank"
                  className="fab fa-linkedin"
                  title="linkedin"
                >
                </a>
              </div>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdSxtJYcmf-c0ABnq7iXycpqx8KgaEiznxPr93axFI_u_VHqQ/viewform?vc=0&c=0&w=1&flr=0&gxids=7757"
                target="_blank"
                className="btn btn-small btn-maincolor ml-xl-4 mr-3 hidden-below-xl"
              >
                Schedule Consultation
              </a>
              {/* <a
                  href="donate.html"
                  className="btn btn-small btn-maincolor2 hidden-below-xl"
                >
                  JMTY Blueprint
                </a> */}
            </div>
          </div>
        </div>
        <span className="toggle_menu">
          <span></span>
        </span>
      </header>
    );
  }
}

export default withRouter(Header);
